import PropTypes from 'prop-types';
var ElementType = typeof Element === 'undefined' ? function () {} : Element;
var propTypes = {
  /**
   * Provides an accessible label for a dialog close button
   *
   * @default `null`
   */
  ariaCloseLabel: PropTypes.string,

  /**
   * Provide a more descriptive and accessible label
   * for a dialog close button
   *
   * @default `null`
   */
  closeLabel: PropTypes.string,

  /**
   * Should the dialog close on outside click.
   *
   * @default `true`
   */
  closeOnOutsideClick: PropTypes.bool,

  /**
   * Used to enable or disable the fullscreen dialog variant
   *
   * @default `false`
   */
  fullScreen: PropTypes.bool,

  /**
   * By default, when a dialog opens the first focusable element will
   * receive focus. With this option a different element can be
   * specified to receive initial focus. Could be a DOM node or a
   * selector string (querySelector).
   *
   * @default `null`
   */
  initialFocus: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /**
   * Provide a size variant for the dialog
   *
   * @default `default`
   */
  size: PropTypes.oneOf(['default', 'full']),

  /**
   * Used to show or hide the dialog
   *
   * @default `false`
   */
  visible: PropTypes.bool,

  /**
   * Prop to add control elements to the footer of the dialog
   *
   * @default null
   */
  controls: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),

  /**
   * Prop for dialog title
   *
   * @default null
   */
  title: PropTypes.node,

  /**
   * Prop to provide summary text for the dialog
   *
   * @default null
   */
  summary: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),

  /**
   * Prop to provide an alternate close trigger
   *
   * @default null
   */
  trigger: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),

  /**
   * Callback when dialog visibility toggles
   *
   * @default `void`
   */
  updateVisible: PropTypes.func,

  /**
   * Callback when the dialog opens
   *
   * @default `void`
   */
  open: PropTypes.func,

  /**
   * Callback when the dialog closes
   *
   * @default `void`
   */
  close: PropTypes.func,

  /**
   * Change component to a different theme variant
   *
   * @default `classic`
   */
  theme: PropTypes.oneOf(['classic', 'chirp']),

  /**
   * Boolean if application is in hybrid mode
   * Hides controls if true
   *
   * @default false
   */
  hybrid: PropTypes.bool
};
export default propTypes;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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